import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { constants, findEntityById } from "@qgiv/core-js";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllRegistration } from "../../../redux/slices/registrationSlice";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import EmergencyContact from "./EmergencyContact";

const ConnectedEmergencyContact = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const { values } = useFormikContext();
    const { Category, Country } = values;

    const isCms = useSelector(selectIsCms);

    const {
        allowableEmergencyContactsForSub = false,
        allowableEmergencyContacts,
        emergencyContactCell,
        emergencyContactEmail,
        enableEmergencyContacts,
    } = useSelector(selectAllP2pSettings);

    const { currentRegistration } = useSelector(selectAllRegistration);
    const categories = useSelector(selectAllCategories);

    const emergencyContactIsVisibleForCategory = Category.length
        ? categories.find(findEntityById(Number(Category[0])))
              .attachEmergencyContacts
        : false;

    const isVisibleByCategory = isCms
        ? true
        : emergencyContactIsVisibleForCategory;

    const isVisible =
        isVisibleByCategory &&
        ((currentRegistration > 0 && allowableEmergencyContactsForSub) ||
            (currentRegistration === 0 && enableEmergencyContacts));

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_DETAILS_STEP,
            state,
        ),
    );
    const { options } = control;

    const { subsectionHeading, additionalText } = options;

    const emergencyContactProps = {
        allowableEmergencyContacts,
        emergencyContactCell,
        emergencyContactEmail,
        options,
        subsectionHeading,
        additionalText,
        isVisible,
        Country,
    };
    return <EmergencyContact {...emergencyContactProps} />;
};

ConnectedEmergencyContact.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedEmergencyContact;
